(() => {
  'use strict';

  document.querySelectorAll('[data-homepage-ai-discovery-cta]').forEach((cta) => {
    cta.addEventListener('click', () => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'homepage_ai_discovery_click');
      }
    });
  });

  const root = document.querySelector('[data-mj-discovery]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const backdrop = root.querySelector('[data-discovery-backdrop]');
  const dialog = root.querySelector('[data-discovery-dialog]');
  const closeButton = root.querySelector('[data-discovery-close]');
  const reopenButton = root.querySelector('[data-discovery-reopen]');
  const ctas = [...root.querySelectorAll('[data-discovery-cta]')];
  const storageKey = root.dataset.storageKey || 'moonJadeWelcomeSeen';
  const configuredDelay = Number.parseInt(root.dataset.openDelay || '700', 10);
  const openDelay = Number.isFinite(configuredDelay)
    ? Math.min(900, Math.max(600, configuredDelay))
    : 700;

  if (!backdrop || !dialog || !closeButton || !reopenButton) return;

  let isOpen = false;
  let previousFocus = null;
  let closeTimer = null;
  let autoOpenTimer = null;
  const inertState = new Map();

  const getFocusable = () => [...dialog.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )].filter((element) => !element.hidden && element.getClientRects().length > 0);

  const hasSeenWelcome = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (_error) {
      return false;
    }
  };

  const markWelcomeSeen = () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (_error) {
      // Storage can be unavailable in private/restricted browser contexts.
      // The component still works for the current page without collecting data.
    }
  };

  const track = (eventName) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName);
  };

  const setBackgroundInert = (value) => {
    [...document.body.children].forEach((element) => {
      if (element === root || element.contains(root) || element.tagName === 'SCRIPT') return;

      if (value) {
        inertState.set(element, Boolean(element.inert));
        element.inert = true;
      } else if (inertState.has(element)) {
        element.inert = inertState.get(element);
      }
    });

    if (!value) inertState.clear();
  };

  const showReopenButton = () => {
    reopenButton.hidden = false;
    window.requestAnimationFrame(() => reopenButton.classList.add('is-ready'));
  };

  const openDialog = ({ source = 'automatic' } = {}) => {
    if (isOpen) return;
    window.clearTimeout(closeTimer);
    window.clearTimeout(autoOpenTimer);
    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    isOpen = true;
    reopenButton.classList.remove('is-ready');
    reopenButton.hidden = true;
    backdrop.hidden = false;
    backdrop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mj-discovery-open');
    setBackgroundInert(true);

    window.requestAnimationFrame(() => {
      backdrop.classList.add('is-open');
      closeButton.focus({ preventScroll: true });
    });

    track(source === 'reopen' ? 'moon_jade_welcome_reopen' : 'moon_jade_welcome_view');
  };

  const closeDialog = ({ reason = 'dismiss', restoreFocus = true } = {}) => {
    if (!isOpen) return;
    isOpen = false;
    markWelcomeSeen();
    backdrop.classList.remove('is-open');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mj-discovery-open');
    setBackgroundInert(false);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = window.setTimeout(() => {
      if (!isOpen) backdrop.hidden = true;
    }, reduceMotion ? 0 : 360);

    showReopenButton();
    if (restoreFocus && previousFocus && document.contains(previousFocus)) {
      previousFocus.focus({ preventScroll: true });
    }
    track('moon_jade_welcome_dismiss');
    root.dispatchEvent(new CustomEvent('moonjade:discovery-close', { detail: { reason } }));
  };

  const trapFocus = (event) => {
    if (!isOpen || event.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus({ preventScroll: true });
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  closeButton.addEventListener('click', () => closeDialog({ reason: 'close_button' }));
  reopenButton.addEventListener('click', () => openDialog({ source: 'reopen' }));
  backdrop.addEventListener('click', (event) => {
    if (event.target === backdrop) closeDialog({ reason: 'backdrop' });
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog({ reason: 'escape' });
      return;
    }
    trapFocus(event);
  });

  ctas.forEach((cta) => {
    cta.addEventListener('click', () => {
      markWelcomeSeen();
      const action = cta.dataset.discoveryCta;
      if (action === 'ai') track('moon_jade_welcome_ai_click');
      if (action === 'shop') track('moon_jade_welcome_shop_click');
    });
  });

  if (hasSeenWelcome()) {
    showReopenButton();
  } else {
    autoOpenTimer = window.setTimeout(() => openDialog({ source: 'automatic' }), openDelay);
  }
})();
